import React from "react";
import CareerNav from "../../components/Navbar/CarrerNav";
import Footer from "../../components/Home/footer/Footer";
import { Helmet } from "react-helmet";
import {
  commitment,
  culture,
  diversity2,
  equity,
  inclusion,
} from "../../Assets";

const Culture = () => {
  return (
    <>
      <Helmet>
        <title> Life at Avijobs: A Culture of Innovation & Impact</title>
        <meta
          name='discription'
          content=' At Avijobs, we foster a culture of innovation, collaboration, and passion for transforming work culture. Join a team that values creativity, growth, and meaningful impact.

'
        />
      </Helmet>
      <div className='App'>
        <CareerNav />
        <Header />
        <ExploreOpportunities />
        <Footer />
      </div>
    </>
  );
};

const Header = () => (
  <header
    className='hero bg-white p-8'
    style={{ fontFamily: "Gilroy-SemiBold" }}
  >
    <div class='flex justify-between p-4 md:flex-row'>
      <div className='w-50 flex h-full flex-col p-12'>
        <div className='flex-grow'>
          <h2 className='text-4xl text-gray-900'>Commited to our Culture</h2>
          <span className='font-sans text-lg'>
            Our culture is driven by the philosophy of continuous growth and
            learning. We believe that innovation and progress are the results of
            a curious and open mind, and we encourage our team members to
            prioritize thinking and learning as much as their daily tasks. We
            foster an environment where ideas can be shared freely, creativity
            is celebrated, and collaboration is key. Our colleagues are more
            than just employee; they are learners, thinkers, and innovators who
            contribute to the dynamic and forward-thinking atmosphere of our
            organization.
          </span>
        </div>
      </div>
      <div className='w-50 ml-20 p-4'>
        <img
          src={culture}
          alt='Culture'
          style={{ width: "100%", height: 300 }}
        />
      </div>
    </div>
  </header>
);

const ExploreOpportunities = () => {
  const contentData = [
    {
      image: diversity2,
      alt: "Diversity and Inclusion",
      title: "Diversity and Inclusion",
      description:
        "We are committed to building a diverse and inclusive workforce where every voice is heard, and every idea is valued. We recognize that a diverse team brings a wide range of perspectives that drive better decision-making and innovation. We strive to create an environment where everyone, regardless of their background, feels welcomed and empowered to succeed.",
    },
    {
      image: equity,
      alt: "Flexibility and Work-Life Balance",
      title: "Flexibility and Work-Life Balance",
      description:
        "We understand the importance of a healthy work-life balance. We offer flexible working hours to help our team members manage their personal and professional lives effectively. Whether it's remote work, flexible start and end times, or accommodating personal needs, we are committed to ensuring our employees have the flexibility they need to thrive.",
    },
    {
      image: inclusion,
      alt: "Unique KYC Feature",
      title: "Unique KYC (Know Your Colleague) Feature",
      description:
        "We prioritize not just finding the right talent but also ensuring that our employees are well-connected and familiar with their workplace environment and colleagues from day one. Our unique KYC (Know Your Colleague) feature is designed to foster a sense of community and trust within our organization, providing an instant placement experience that seamlessly integrates new hires into our team. This approach helps build strong, collaborative relationships from the start, ensuring that everyone feels part of the Avijobs family.",
    },
    {
      image: commitment,
      alt: "Instant Placement",
      title: "Instant Placement",
      description:
        "We strive to match talent with opportunities quickly and efficiently. Our instant placement process ensures that new hires can begin contributing to their teams without unnecessary delays, making the transition smooth and effortless for both employees and employers.",
    },
  ];

  const Card = ({ item }) => {
    const { image, alt, title, description } = item;
    return (
      <div className='w-full p-4 sm:w-1/2 md:w-1/4'>
        <img
          src={image}
          alt={alt}
          className='mb-4 h-40 w-full rounded-lg'
          loading='lazy'
        />
        <h6 className='mb-2 text-xl text-blue-600'>{title}</h6>
        <p className='text-sm text-gray-600'>{description}</p>
      </div>
    );
  };

  return (
    <section className='bg-white py-5'>
      <div className='explore container'>
        <h3 className='mb-8 font-[Gilroy-SemiBold] text-[#636363]'>
          We Think & Learn More Than We Work
        </h3>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {contentData.map((content, index) => (
            <Card item={content} key={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Culture;
